import React from 'react'

import Layout from '../layouts/en'
import SEO from '../components/seo'

import Bubble from '../components/Bubble'
import IntroBox from '../components/IntroBox'
import IllustrationBox from '../components/IllustrationBox'
import Testimonial from '../components/Testimonial'

import FlickitySlider from '../components/FlickitySlider'

import VocationalTraineeesTables from '../components/VocationalTraineeesTables'
import OccupationalAssessmentCandidateTable from '../components/OccupationalAssessmentCandidateTable'

//  Data
const HotelTeamMembers = require('../data/HotelTeamMembers')

const IndexPage = (props) => (
  <Layout location={props.location}>
    <SEO title="Tourism and Hotel School" />

    <div
      className="bg-banner-30 bg-center bg-cover"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/bg-hotel.jpg)`, minHeight: '200px' }}
      id="onward-to-success"
    >
      <div className="absolute inset-0 py-12">
        <div className="container" data-aos="fade-up" data-aos-delay={400} data-aos-duration={1200}>
          <Bubble className="w-full md:w-1/2"
            title="Onward to Success"
            subtitle=""
          >
          </Bubble>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container">
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-1/3">
            <div className="inset-0" data-aos="fade-right">
              <img src="/AnnualReport2017-2018/images/hotel/7.1.2.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
          <div className="w-full lg:w-2/3 flex" data-aos="fade-left">
            <div className="text-left mx-auto text-sm lg:text-base lg:pl-8 font-normal mt-4 lg:mt-0 text-justify">
              <p className="mb-4">The IFT Tourism and Hotel School focuses on student’s long development and success in their career path in tourism, hospitality and other service industries. For more than two decades we have offered courses that lead to qualifications recognised internationally and that reflect the needs of the market.</p>
              <p className="mb-4">The professional training programmes and certified assessments attracted nearly 20,000 participants each year. Courses at the foundation, intermediate and advanced levels were offered to match the abilities as well as requirements of different students. Our certificates and diplomas are offered in partnership with 20 institutions in Mainland China and around the world, and widely recognised by tourism and hospitality industries, local and abroad. </p>
              <p className="mb-4">The IFT Tourism and Hotel School, in collaboration with the Macao Education and Youth Affairs Bureau, designed 2 tailor-made courses for high school students, namely: the Tourism Techniques Course and the Graphic Design Course. The 3-year courses comprise academic and occupational learning, students of the courses also receive opportunities for internships. </p>
              <p className="mb-4">The IFT Tourism and Hotel School also offers pre-service vocational courses to introduce the hospitality, food and beverage, and events businesses to high school pupils, so that they can get more information about tourism and hospitality industry before deciding on their future study and career path.</p>
              <p className="mb-4">As the leading institute in lifelong learning, IFT offers a wide range of training courses for the service industries. All Macao residents are welcome to join the IFT Community Education and Development Programme without any charges, the programmes are associated with community associations and IFT partners. </p>
              <p>Throughout the year, special seminars and workshops on the food and beverage business and cultural tourism are arranged by IFT. These sessions help broaden participants’ horizons as they are often jointly arranged with partners abroad.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="eight-major-area">
      <div className="container mb-12">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">Eight Major Area</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full flex">
            <div className="text-left mx-auto text-sm md:text-base max-w-5xl font-normal" data-aos="fade-up">
              <p>To support the development of Macao’s economy diversification and enhance the development of local employee career path. IFT Tourism and Hotel School offers courses relating to 8 major areas, namely: Hospitality; Food and Beverage; Heritage and Tourism; Retail, Events and Business; Creative Studies and IT; Health, Spa and Beauty; Language and Culture; Personal development.</p>
            </div>
          </div>
        </div>
      </div>

      <div
        className="bg-banner-30 bg-center bg-cover"
        style={{ backgroundImage: `url(/AnnualReport2017-2018/images/hotel/7.1.1.jpg)` }}
      >
      </div>

      <div className="container mt-12">
        <div className="flex flex-wrap">
          <div className="w-full md:w-1/2 md:pr-4" data-aos="zoom-out">
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">Hospitality</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>Courses offered in the area of hospitality cover a wide range of topics and levels, extending from occupational skills to managerial concepts. In addition, we collaborate with international training organisations offering accredited qualifications for career development.</p>
            </div>
          </div>
          <div className="w-full md:w-1/2 md:pl-4 mt-12 md:mt-0" data-aos="zoom-out" data-aos-delay={150}>
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">Food and Beverage</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>A variety of high quality professional training programmes is offered to the F&B service industry staff and to the community in general. Courses cover F&B management, restaurant front line service, bar operation, culinary art as well as food product knowledge. Tourism and Hotel School also collaborates with international organisations, such as Ferrandi Paris, Le Cordon Bleu, Specialty Coffee Association, Wines of Portugal Academy, etc. As Macao was designated UNESCO Creative City of Gastronomy, we are devoted to continuously develop more local traditional culinary courses.</p>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap mt-12">
          <div className="w-full md:w-1/2 md:pr-4" data-aos="zoom-out">
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">Heritage and Tourism</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>Courses in Heritage and Tourism studies are provided to nurture professionals in the field; they include “Tour Guide Training” in multi-languages, “Cultural Heritage Interpretation for World Heritage Sites”, “Macao Heritage Tour Guide” and “Supervision in Travel Agency”. Collaboration with IATA/UFTAA for International Travel Agent Foundation Course is also offered. Public seminars of different cultural and tourism topics are regularly provided.</p>
            </div>
          </div>
          <div className="w-full md:w-1/2 md:pl-4 mt-12 md:mt-0" data-aos="zoom-out" data-aos-delay={150}>
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">Retail, Events and Business</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>The Retail, Events and Business team offers a series of retail courses in selling techniques, shop operations, merchandising, marketing and visual merchandising to cope with the needs of fast development of the retail industry. Tourism and Hotel School also offer a series of financial management, business management and accounting courses from entry to managerial levels. For those who are interested in the event industry, the school offers courses such as Wedding & Event Planning and Public Relations.</p>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap mt-12">
          <div className="w-full md:w-1/2 md:pr-4" data-aos="zoom-out">
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">Creative Studies and IT</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>To cope with the development of cultural and creative industry and to support Macao in becoming a smart city, Tourism and Hotel School offers courses related to Creative Arts and Information Technology. They cover art and design training, information technology learning and creative thinking development.</p>
            </div>
          </div>
          <div className="w-full md:w-1/2 md:pl-4 mt-12 md:mt-0" data-aos="zoom-out" data-aos-delay={150}>
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">Health, Spa and Beauty</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>Tourism and Hotel School collaborates with international training organisations offering accredited qualifications for career development. Some of our students’ popular picks are personal fitness trainer, Yoga instructor, professional makeup, food safety and nutrition courses. The newly launched Pilates instructor course and sports massage trainer course are also their favourites.</p>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap mt-12 mb-8">
          <div className="w-full md:w-1/2 md:pr-4" data-aos="zoom-out">
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">Language and Culture</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>To enhance the language skills of the general public, Tourism and Hotel School offers a wide range of language courses including English, Portuguese, Mandarin, Cantonese, Japanese, Korean and French. The courses consist of different levels suitable for absolute beginners and near native speakers of the language. Different tailor courses are provided for professionals from hospitality, catering and retail industries, and provide a series of pre-vocational training programmes for local high school students.</p>
            </div>
          </div>
          <div className="w-full md:w-1/2 md:pl-4 mt-12 md:mt-0" data-aos="zoom-out" data-aos-delay={150}>
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">Personal development</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>Tourism and Hotel School also focuses in students’ self-development, the courses covered area included: interpersonal relationship, communication skill, PR etiquette, personal relationship and so forth, to embrace students to face challenges that they face in life and work.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 lg:py-12 md:pb-0">
      <div className="container flex flex-wrap">
        <div className="flex mt-8 w-full lg:w-1/2" data-aos="zoom-in">
          <Testimonial
            title="Tourism and Hotel School offers Vocational Courses in:"
            color="blue"
            className="w-full"
          >
            <ul className="list-disc"><li>Hospitality</li><li>Food and Beverage</li><li>Heritage and tourism</li><li>Retail, Events and Business</li><li>Creative studies and IT</li><li>Health, spa and beauty</li><li>Language and culture</li><li>Personal development</li></ul>
          </Testimonial>
        </div>
        <div className="flex mt-8 w-full lg:w-1/2 lg:pl-12" data-aos="flip-down">
          <div className="inset-0">
            <img src="/AnnualReport2017-2018/images/hotel/Restaurant-1.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:pb-24">
      <div className="container flex flex-wrap">
        <div className="flex mt-8 w-full lg:w-1/2" data-aos="flip-down">
          <div className="inset-0">
            <img src="/AnnualReport2017-2018/images/hotel/7.1.3.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
          </div>
        </div>
        <div className="flex mt-8 w-full lg:w-1/2 lg:pl-12" data-aos="zoom-in">
          <Testimonial
            title="Continuing Education"
            color="orange"
          >
            <p className="mb-4">The core of the IFT Tourism and Hotel School is lifelong learning. To further holistic education, various training programmes are provided to Macao residents. In 2008 the IFT Tourism and Hotel School joined the Continuing Education Subsidy Scheme initiated by the Macao Education and Youth Affairs Bureau to promote lifelong learning. The scheme was replaced by the Continuing Education Development Plan in 2011. </p>
            <p>By August 2018, IFT had applied to offer about 1,670 courses subsidised by these initiatives, and these subsidised courses had a total of 16,292 participants. In academic year 2017/18, IFT had applied to have about 290 courses subsidised by these initiatives, and these courses had 2,558 participants.</p>
          </Testimonial>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-12">
      <div className="container">
        <div data-aos="fade-up">
          <VocationalTraineeesTables
            langKey={props.pageContext.langKey}
            className="mb-12"
          />
        </div>

        <div data-aos="fade-up">
          <OccupationalAssessmentCandidateTable
            langKey={props.pageContext.langKey}
          />
        </div>
      </div>
    </div>

    <div
      className="bg-banner-30 bg-center bg-cover py-12"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/hotel/7.2.1.jpg)` }}
    >
    </div>

    <div className="py-8 md:py-12 md:pb-24" id="our-professional-training-staff">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">Our Professional Training Staff</h2>
        <div className="w-full md:w-1/2 mx-auto my-12 text-center" data-aos="fade-up">
          <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">Course Coordinators</h4>
          <div className="mx-auto text-sm md:text-base font-normal">
            <p>Our highly qualified coordinators are dedicated to help students to succeed in their development and careers. Our team establishes and executes a wide variety of systematic teaching plans that are meant to give people greater opportunities to achieve new heights in their career.</p>
          </div>
        </div>

        <FlickitySlider>
          {
            HotelTeamMembers.map((member, i) => (
              <div key={i} className="w-full md:w-1/4 mb-12 text-center">
                <div className="flex flex-col items-center mx-4">
                  <img src={`/AnnualReport2017-2018${member.image}`} alt="member" className="rounded-full w-40 h-40 mb-2" />

                  <div className="w-full text-2xl text-blue-500">
                    { member.name['en'] }
                  </div>
                  <div className="w-2/3 mb-2">
                    { member.title['en'] }
                  </div>
                  <div className="w-full text-sm font-normal">
                    { member.description['en'] }
                  </div>
                </div>
              </div>
            ))
          }
        </FlickitySlider>

      </div>
    </div>

    <div
      className="bg-banner-30 bg-center bg-cover py-12"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/hotel/7.3.1.jpg)` }}
    >
    </div>

    <div className="bg-gray-200 py-8 md:py-12">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">Skills Certified</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full md:w-2/3 flex" data-aos="fade-right">
            <div className="text-left mx-auto text-sm md:text-base md:pr-8 font-normal text-justify">
              <p className="mb-4">The Macao Occupational Skills Recognition System (MORS) is a crucial long-term endeavour by the IFT Tourism and Hotel School. The system is the result of a joint effort by the Macao tourism industry and IFT to establish a scheme for training people in certain field and for certifying workers as being sufficiently qualified.</p>
              <p className="mb-4">The goal of MORS is to enhance the performance of workers in the hotel and tourism industry by certifying their skills in handling front-line jobs. MORS certificates are the approval for workers and their skills, and the certificates are widely recognised by the tourism industry in Macao.</p>
              <p className="mb-4">MORS was introduced in 2001, with the support of the European Union. The Pacific Asia Travel Association (PATA) has given the scheme the PATA Gold Award in Education and Training.</p>
              <p className="mb-4">At least 2 rounds of intensive preparatory courses and skills assessment are organised annually. Longer preparatory courses meant for the general public were first offered in 2010 in an effort to keep up with the rapid development of the tourism and hospitality industries in Macao.</p>
              <p>Since 2002, IFT organises the annual Gold Pin competition, which is to award the outstanding performers in their own occupations covered by the system. In academic year 2017/18, 20 participants won the awards.</p>
            </div>
          </div>
          <div className="w-full md:w-1/3 mt-12 md:mt-0" data-aos="fade-left">
            <div className="flex flex-col">
              <div className="w-1/4 md:w-1/3 mx-auto">
                <img src="/AnnualReport2017-2018/images/hotel/7.3.2.png" alt="" className="block rounded-full" />
              </div>
              <div className="text-left mx-auto text-sm md:text-base mt-6">
                <p className="text-blue-700">“At the end of the day, our customers are taken care of by the people who are on the front line: the waiters, the waitresses, the housekeeping staff, the security and front-office team. All of these workers are the people that make a difference for us in Macao. The MORS programme celebrates their efforts.”</p>
                <p className="mt-4 text-gray-700"><strong>Grant Bowie&nbsp; <br/></strong>Chief Executive Officer - integrated resort operator MGM China Holdings</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container">
        <div className="flex flex-row flex-wrap">
          <div className="w-full md:w-2/3" data-aos="zoom-out">
            <Testimonial
              title="MORS-Certifiable Occupations"
              color="orange"
            >
              <div className="flex flex-wrap">
                <div className="w-full md:w-1/2">
                  <ul className="list-disc"><li>Assistant Cook (Western kitchen)</li><li>Bartender</li><li>Chinese Cook - Cantonese Cuisine (Elementary)</li><li>Chinese Cook - Cantonese Cuisine (Intermediate)</li><li>Chinese Cook - Cantonese Dim Sum (Elementary)</li><li>Chinese Cook - Cantonese Dim Sum (Intermediate)</li><li>Concierge and Bell Attendant</li><li>Floral Designer </li><li>Front Desk Agent</li></ul>
                </div>
                <div className="w-full md:w-1/2">
                  <ul className="list-disc md:pl-8"><li>Customer Relations Officer</li><li>Retail Sales Officer</li><li>Room Attendant</li><li>Security Officer for Tourism and Gaming Industry</li><li>Travel Consultant</li><li>Waiter/Waitress (Chinese Restaurant Service)</li><li>Waiter/Waitress (Western Restaurant Service)</li><li>Western Pastry and Bakery Chef</li></ul>
                </div>
              </div>
            </Testimonial>
          </div>
          <div className="w-full md:w-1/3 md:pl-8" data-aos="zoom-out">
            <IllustrationBox
              number={1742}
              image="/images/certificate.gif"
              text="Participant joined the training programmes and were certified by the MORS in academic year 2017/18"
              className="text-4xl"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="be-creative">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">Be Creative</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-2/3 flex">
            <div className="text-left mx-auto text-sm lg:text-base lg:pr-8 font-normal text-justify" data-aos="fade-right">
              <p className="mb-4">One of the main goals of IFT Tourism and Hotel School is to foster the development of Macao’s economy diversification. Since then, IFT Tourism and Hotel School has been expanding the courses it offers in the cultural and creative field. These courses enrich skills and knowledge of Macao residents and support the development of Macao’s cultural and creative industries, as envisioned by the Macao SAR Government.</p>
              <p className="mb-4">The IFT Tourism and Hotel School offers an extensive number of programmes of various duration and degrees of specialisation for the study of creative subjects. The subjects covered range from fine art painting, video editing to crafting leather accessories. All programmes are designed with different levels, nature and topics, to suit different needs of students.</p>
              <p className="mb-4">The curial role of IFT in teaching and training residents to work in cultural industries has been consolidated in recent years. The Institute has been given a seat on the Committee of Cultural Industries, as an advisory body to the Government.</p>
              <p>The IFT Tourism and Hotel School also promotes culture and the arts in Macao on a regular basis, activities included art exhibitions in Mong-Há Campus and IFT Café at Anim’Arte NAM VAN which are open to public for free. Exhibitors included IFT teachers and their pupils who were often invited to showcase their work.</p>
            </div>
          </div>
          <div className="w-full lg:w-1/3 mt-4 lg:mt-0" data-aos="fade-left">
            <div className="inset-0">
              <img src="/AnnualReport2017-2018/images/hotel/7.3.6.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container">
        <div className="flex flex-row flex-wrap" data-aos="zoom-out">
          <div className="w-full">
            <Testimonial
              title="Courses - Academic Year 2017/18:"
              color="blue"
            >
              <div className="flex flex-wrap">
                <div className="w-full md:w-1/2">
                  <ul className="list-disc md:pr-6"><li>Corporate Identity Design</li><li>Advertising Design</li><li>Photography</li><li>Floral Design</li><li>Souvenir Design and Production</li><li>Chinese and Western Painting</li></ul>
                </div>
                <div className="w-full md:w-1/2">
                  <ul className="list-disc"><li>Chinese Calligraphy & Old English Calligraphy</li><li>Contemporary Ceramics</li><li>Leather-carving Crafts</li><li>Do-it-yourself Recycling Design and Production</li><li>Art Administration</li><li>Visual Art Marketing and Management</li></ul>
                </div>
              </div>
            </Testimonial>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12 md:pb-16" id="the-ift-tourism-and-hotel-school-held-4-art-exhibitions-in-2017-18">
      <div className="container">
        <h4 className="text-2xl md:text-2xl text-blue-600 text-center mb-12" data-aos="fade-down">The IFT Tourism and Hotel School held 4 Art Exhibitions in 2017/18:</h4>
        <div className="flex flex-wrap">
          <div className="flex w-full lg:w-2/3 flex-wrap">
            <div className="w-full md:w-1/2 md:pr-4" data-aos="zoom-out">
              <h4 className="text-xl md:text-xl text-indigo-700 mb-2">Documenting Impermanence</h4>
              <div className="text-left mx-auto text-sm md:text-base">
                <p>An Exhibition of Reportage Photography by Alice Kok and Students</p>
                <p className="mt-4 text-gray-600 text-sm">15 December 2017 to 31 March 2018, IFT Mong-Há Campus</p>
              </div>
            </div>
            <div className="w-full md:w-1/2 md:pl-4 mt-8 md:mt-0" data-aos="zoom-out" data-aos-delay={150}>
              <h4 className="text-xl md:text-xl text-indigo-700 mb-2">Creativity in Spring II</h4>
              <div className="text-left mx-auto text-sm md:text-base">
                <p>An Exhibition of Student Works</p>
                <p className="mt-4 text-gray-600 text-sm">30 April - 31 July 2018, IFT Mong-Há Campus</p>
              </div>
            </div>
            <div className="w-full md:w-1/2 md:pr-4 mt-8" data-aos="zoom-out">
              <h4 className="text-xl md:text-xl text-indigo-700 mb-2">Photosynthesis II</h4>
              <div className="text-left mx-auto text-sm md:text-base">
                <p>Tang Kuok Hou Photography Exhibition</p>
                <p className="mt-4 text-gray-600 text-sm">6 October - 31 December 2017, IFT Café</p>
              </div>
            </div>
            <div className="w-full md:w-1/2 md:pl-4 mt-8" data-aos="zoom-out" data-aos-delay={150}>
              <h4 className="text-xl md:text-xl text-indigo-700 mb-2">Twenty Hours</h4>
              <div className="text-left mx-auto text-sm md:text-base">
                <p className="mb-4">An Exhibition of Abstract Painting by Denis Murrell and his Students</p>
                <p className="mt-4 text-gray-600 text-sm">12 January - 2 March 2018, IFT Café</p>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/3 mt-12 lg:mt-0">
            <div className="inset-0" data-aos="flip-down" data-aos-delay={150}>
              <img src="/AnnualReport2017-2018/images/hotel/7.3.5.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      className="bg-banner-30 bg-center bg-cover py-12"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/hotel/7.3.4.jpg)` }}
    >
    </div>

    <div className="py-8 md:py-12 md:pb-16" id="together-for-future-success">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">Together for Future Success</h2>
        <div className="mx-auto text-sm md:text-base w-full md:4/5 lg:w-2/3 text-center mt-4 mb-12 font-normal" data-aos="fade-up">
          <p>The IFT Tourism and Hotel School cooperate with public bodies and private organisations to offer tailor-made courses and training to meet their needs, and optimise the quality of the courses.</p>
        </div>

        <div className="flex flex-row flex-wrap">
          <div className="w-full md:w-1/2 mb-8 flex" data-aos="fade-right">
            <IntroBox className="mx-2 text-sm md:text-base h-full"
              title="Visual Art Marketing and Management"
              image="/images/hotel/Visual-Art.jpg"
            >
              <p className="mb-4">Joining hands with the Cultural Affairs Bureau, the IFT Tourism and Hotel School offers 2 programmes, namely the “Certificate in Art Administration” and “Certificate in Performing Arts Events Management” annually, with the goal to develop employees’ skills on exhibitions and events planning, organisation and management, and nurture the development of Macao’s cultural and creative industries, fostering Macao’s economy diversification.</p>
              <p>Co-organised by the Cultural Affairs Bureau and IFT, “Certificate in Visual Art Marketing and Management” programme was offered for the first time in 2017, as a response to the rapid development and demand for talents in the field of visual art in Macao. The first cohort of students was taught by lecturers from Macao, Hong Kong and Mainland China. The 177-hour programme consists of theoretical and practical study. The classes cover subjects ranging from marketing to art gallery management to art investment.</p>
            </IntroBox>
          </div>
          <div className="w-full md:w-1/2 mb-8 flex" data-aos="fade-left">
            <IntroBox className="mx-2 text-sm md:text-base h-full"
              title="Manner Courses"
              image="/images/hotel/IMG_0492.JPG"
            >
              <p className="mb-4">The public images of police force are extremely important. The IFT Tourism and Hotel School is commissioned by the Academy for Public Security Forces to train front-line police officers in soft skills since 2015. The training including speaking foreign languages and conveying information about Macao’s heritage, officers are also instructed in etiquette and communication skills.</p>
              <p className="mb-4">The tailor-made training programme covered important aspects related to daily interactions with visitors. The programme optimises officers’ performance in their daily duties, and contributes to the development of Macao as a World Centre of Tourism and Leisure.</p>
              <p>The target of the programme is to train around 1,000 officers before 2020. Ten courses are organised each year, with about 25 officers in each course. Since 2015, 736 officers have completed the programme. In academic year 2017/18, 4 courses were offered and 150 students have completed the training.</p>
            </IntroBox>
          </div>
          <div className="w-full md:w-1/2 mb-8 flex" data-aos="fade-right">
            <IntroBox className="mx-2 text-sm md:text-base h-full"
              title="Lifelong Learning"
              image="/images/hotel/IMG_0491.JPG"
            >
              <p className="mb-4">IFT Tourism and Hotel School has been working closely with the industry to help Macao residents on their career development and enhance their upward movement. Courses are organised for the Macau Hotel Association at foundation, intermediate and advanced levels, covering areas of languages, food and beverages, supervision, management and so forth, courses may also be modified to suit specific needs of individual organisations. In academic year 2017/18, about 6,390 industry professionals coming from 32 local establishments attended our customised courses. </p>
              <p>Besides, the IFT Tourism and Hotel School also works closely with local enterprises including Venetian Macau Limited and Melco Resorts & Entertainment to offer management programmes for their local employees. Participants were given the chance to enhance their knowledge and skills through applying in their workplace the theory they learn at classes. The programmes also prepared them to take international qualification examinations. The main objective of the programmes is to help local professionals develop their career and to move to higher management levels.</p>
            </IntroBox>
          </div>
          <div className="w-full md:w-1/2 mb-8 flex" data-aos="fade-left">
            <IntroBox className="mx-2 text-sm md:text-base h-full"
              title="Escalating F&B Training"
              image="/images/hotel/Escalating-F&B-Training.jpg"
            >
              <p className="mb-4">The IFT Tourism and Hotel School has been devoting its effort to offering diversified F&B courses to the industry. Courses including “culinary diploma programmes”, “evening culinary short courses” and “international qualification courses” and so forth are offered to fulfil the needs of different requirement. In the academic year 2017/18, the school offered 150 short courses in different levels, with 2,680 students having completed the training. Apart from diploma programmes, international qualification courses, workshops and seminars conducted by overseas and mainland experts and professionals were also been organised in 2017/18.</p>
              <p>F&B courses include culinary diploma programmes (Diploma in Pastry and Bakery and Diploma in Western Culinary Skills), evening culinary short courses (Chinese cuisine, Chinese dim sum, Portuguese and Macanese, Spanish, Italian, Japanese cuisine, etc); international qualification courses, workshops and seminars conducted by overseas and mainland experts and professionals, etc.</p>
            </IntroBox>
          </div>
          <div className="w-full md:w-1/2 mb-8 flex" data-aos="fade-right">
            <IntroBox className="mx-2 text-sm md:text-base h-full"
              title="Course for Cultural Tours on Fishing Industry"
              image="/images/hotel/Fishing.jpg"
            >
              <p>Fishing industry is one of oldest industries in Macao. In June 2018, the IFT Tourism and Hotel School, joined with the Labour Affairs Bureau and the History and Culture Association, organised the “Course for Cultural Tours on Macao’s Traditional Fishing Industry” for the fishery workers. The course covered information from local history, costal tourism attractions, customer service skills and public speaking. The goal is to prepare them to be docents for water tours. </p>
            </IntroBox>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
